<template>

  <div class="cc-card cc-calendar-month">

      <!-- <CalendarDateIndicator
        :selected-date="selectedDate"
        class="cc-calendar-month-header-selected-month"
      /> -->

    <CalendarDateSelector
      :current-date="today"
      :selected-date="selectedDate"
      @dateSelected="selectDate"
    />

    <div class="cc-divider mb-4"></div>

    <div class="cc-flex">

      <div class="cc-calendar-container">
        
        <CalendarWeekdays/>
        
        <ol class="cc-days-grid">

          <CalendarMonthDayItem
            v-for="day in days"
            :key="day.date"
            :day="day"
            :is-today="day.date === today"
            :is-arrival="day.date === arrival"
            :is-departure="day.date === departure"
            :is-arrival-day="isArrivalDay(day)"
            :is-departure-day="isDepartureDay(day)"
            :is-disabled="isDisabled(day.date)"
            :in-range="isInRange(day)"
            @daySelected="setSelectedDays"
          />

        </ol>

      </div>
      
    </div>

  </div>

</template>

<script>
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import isBetween from "dayjs/plugin/isBetween";

import CalendarMonthDayItem from "./CalendarMonthDayItem";
// import CalendarDateIndicator from "./CalendarDateIndicator";
import CalendarDateSelector from "./CalendarDateSelector";
import CalendarWeekdays from "./CalendarWeekdays";

dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(isBetween);

import store from "../../store";
import { mapGetters } from "vuex";

export default {
  store,
  name: "CalendarMonth",

  components: {
    CalendarMonthDayItem,
    // CalendarDateIndicator,
    CalendarDateSelector,
    CalendarWeekdays
  },

  data() {
    return {
        selectedDate: store.state.priceCalculation.priceCalculation !== null && store.state.priceCalculation.priceCalculation.arrival !== null ? dayjs(store.state.priceCalculation.priceCalculation.arrival) : dayjs(),
      // disabledDates: ['2020-11-25','2020-11-26']
    };
  },


  props: {

    arrival_dates: {
      type: Object,
      default: null
    },
    departure_dates: {
      type: Object,
      default: null
    },
    disabledDates: {
      type: Object,
      default: null
    },

  },

  // model: {
	// 	prop: "selectedDays",
	// 	event: "selectedDays",
	// },

  computed: {
    days() {
      return [
        ...this.previousMonthDays,
        ...this.currentMonthDays,
        ...this.nextMonthDays
      ];
    },

    today() {
      return dayjs().format("YYYY-MM-DD");
    },

    month() {
      return Number(this.selectedDate.format("M"));
    },

    year() {
      return Number(this.selectedDate.format("YYYY"));
    },

    numberOfDaysInMonth() {
      return dayjs(this.selectedDate).daysInMonth();
    },

    currentMonthDays() {
      return [...Array(this.numberOfDaysInMonth)].map((day, index) => {
        return {
          date: dayjs(`${this.year}-${this.month}-${index + 1}`).format(
            "YYYY-MM-DD"
          ),
          isCurrentMonth: true
        };
      });
    },

    previousMonthDays() {
      const firstDayOfTheMonthWeekday = this.getWeekday(
        this.currentMonthDays[0].date
      );
      const previousMonth = dayjs(`${this.year}-${this.month}-01`).subtract(
        1,
        "month"
      );

      // Cover first day of the month being sunday (firstDayOfTheMonthWeekday === 0)
      const visibleNumberOfDaysFromPreviousMonth = firstDayOfTheMonthWeekday
        ? firstDayOfTheMonthWeekday - 1
        : 6;

      const previousMonthLastMondayDayOfMonth = dayjs(
        this.currentMonthDays[0].date
      )
        .subtract(visibleNumberOfDaysFromPreviousMonth, "day")
        .date();

      return [...Array(visibleNumberOfDaysFromPreviousMonth)].map(
        (day, index) => {
          return {
            date: dayjs(
              `${previousMonth.year()}-${previousMonth.month() +
                1}-${previousMonthLastMondayDayOfMonth + index}`
            ).format("YYYY-MM-DD"),
            isCurrentMonth: false
          };
        }
      );
    },

    nextMonthDays() {
      const lastDayOfTheMonthWeekday = this.getWeekday(
        `${this.year}-${this.month}-${this.currentMonthDays.length}`
      );

      const nextMonth = dayjs(`${this.year}-${this.month}-01`).add(1, "month");

      const visibleNumberOfDaysFromNextMonth = lastDayOfTheMonthWeekday
        ? 7 - lastDayOfTheMonthWeekday
        : lastDayOfTheMonthWeekday;

      return [...Array(visibleNumberOfDaysFromNextMonth)].map((day, index) => {
        return {
          date: dayjs(
            `${nextMonth.year()}-${nextMonth.month() + 1}-${index + 1}`
          ).format("YYYY-MM-DD"),
          isCurrentMonth: false
        };
      });
    },

    arrival() {

      if(this.settings && this.settings.arrival){
        return this.settings.arrival ;
      }else{
        return null ;
      }
			
    },
    
    departure() {

      if(this.settings && this.settings.departure){
        return this.settings.departure ;
      }else{
        return null ;
      }
			
    },

    nights() {

      if(this.settings && this.settings.nights){

        for (let i = 0; i <= this.nights; i++) {
          
          let newdate = dayjs(this.arrival).add(i, 'day') ;

          if(this.isDisabled(newdate.format('YYYY-MM-DD'))){

            store.commit('app/set_departure', null ) ;
            store.commit('app/set_arrival', null) ;

          }

        }
        
        return this.settings.nights ;


      }else{
        return 0 ;
      }
			
    },
    
    // map `this.administrationTest` to `this.$store.getters.administrationTest`
    ...mapGetters({
        settings: "app/settings",
        administration: "administration/get",
        priceCalculation: "priceCalculation/get"
    })
    
  },

  methods: {
    getWeekday(date) {
      return dayjs(date).weekday();
    },

    selectDate(newSelectedDate) {
      this.selectedDate = newSelectedDate;
    },
    setSelectedDays(day){
      
      // change arrival date if this day is before arrival
      if(
        this.arrival && 
        !this.departure && 
        (
          dayjs(day.date).isAfter(dayjs(this.arrival)) ||
          dayjs(day.date).isSame(dayjs(this.arrival)) 
        )
      ){
          
      store.commit('app/set_departure', day.date);

      // }else if(
      //   this.arrival && 
      //   !this.departure && 
      //   dayjs(day.date).isBefore(dayjs(this.arrival)) 
      // ){

      //   console.log('SETT DEPARTURE');

      //   store.commit('app/set_departure', this.arrival );
      //   store.commit('app/set_arrival', day.date);

      }else{
        
        store.commit('app/set_arrival', day.date );
        store.commit('app/set_departure', null);

      }

      store.dispatch('priceCalculation/get') ;
      
    },
    isInRange(day){

      if(this.arrival && this.departure){
        return dayjs(day.date).isBetween(this.arrival, this.departure, null, '[]') ;
      }
      
      return false; 

    },
    isDisabled(date, checkDayBefore = true){

      if(dayjs(date).isBefore() && this.today != date){
        return true ;
      }

      if(dayjs(date).isAfter(dayjs().add(365, 'day'))){
        return true ;
      }

      // check if this is the first disabled date.
      if(
        checkDayBefore && 
        this.arrival && 
        !this.departure){

          let checkdate = dayjs(date).subtract(1, 'day') ; 

          if(!this.isDisabled(checkdate.format("YYYY-MM-DD"), false)){
            return false ;
          }

      }

      return this.disabledDates.includes(date) ;

    },
    isArrivalDay(day){

      // when arrival day is selected and no departure days
      // console.log('this.arrival') ;
      // console.log(this.arrival_dates) ;

      if(
        this.arrival && !this.departure
      ){
        return false ;
      }

      return this.is_ArrivalOrDepartureDay(day, 'arrival_dates');

    },
    isDepartureDay(day){

      // console.log('type isDepartureDay', this.departure_dates); 

      // when no arrival is selected,
      // or when both are selected,
      // we only show the arrival days.

      if(
        !this.arrival ||
        (this.arrival && this.departure)
      ){
        return false ;
      }

      return this.is_ArrivalOrDepartureDay(day, 'departure_dates');

    },
    is_ArrivalOrDepartureDay(day, type){

      // if no arrival or departure days exists, every day is true.
      // console.log('type', this[type]); 

      let isTypeDay = false ;

      if(!this[type]){
        isTypeDay = true ;
      }

      let isException = false ;
      let dayofweek = dayjs(day.date).day() ;

      // sunday is 7 in CC, 0 in Day JS
      if(dayofweek == 0){ dayofweek = 7 ; }

      // check if this date matches an exception
      if(this[type]){
          
        if(
          this[type].exceptions &&
          this[type].exceptions.length > 0
        ){
          
          this[type].exceptions.forEach((exception) => {

            if(dayjs(day.date).isBetween(exception.start, exception.end, null, '[]')){
              
              isException = true ;

              if(exception.days.includes(dayofweek)){
                
                isTypeDay = true ;

              }

            }

          });

        }

        // if this is not an exception,
        // check if this is a default arrival or departure day

        if(!isException){

          if(this[type].default.includes(dayofweek)){
            
            // console.log('IS DEFAULT DAYYYY '+day.date) ;
            isTypeDay = true ;

          }

        }   

      }   

      return isTypeDay ;   

    }

  }
};
</script>